import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";
import { FAQS } from "../../data/content";

export const FAQSection = () => (
  <section className="py-24 sm:py-32" data-testid="faq-section">
    <div className="max-w-4xl mx-auto px-6 md:px-12">
      <div className="mb-14 text-left">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-blue-500">FAQ</span>
        <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-none text-white mt-4">
          Common Questions
        </h2>
      </div>

      <Accordion type="single" collapsible className="space-y-3">
        {FAQS.map((faq, i) => (
          <AccordionItem
            key={faq.q}
            value={`faq-${i}`}
            className="bg-[#121212] border border-zinc-800 rounded-xl px-6 data-[state=open]:border-blue-500/40"
          >
            <AccordionTrigger
              data-testid={`faq-trigger-${i}`}
              className="text-white font-heading font-medium text-left hover:no-underline hover:text-blue-400 py-5"
            >
              {faq.q}
            </AccordionTrigger>
            <AccordionContent className="text-zinc-400 leading-relaxed pb-5">
              {faq.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
